'use strict';

define([], function () {
    var polyfill = {};

    // 兼容getElementsByClassName
    polyfill.getElementsByClassName = function (className, node, tagName) {
        node = node || document;
        tagName = tagName || '*';
        if (node.getElementsByClassName) {
            return node.getElementsByClassName(className);
        }
        var classElements = [];
        var elements = node.getElementsByTagName(tagName);
        var elementsLen = elements.length;
        var pattern = new RegExp('(^|\\s)' + className + '(\\s|$)');
        for (var i = 0; i < elementsLen; i++) {
            if (pattern.test(elements[i].className)) {
                classElements.push(elements[i]);
            }
        }
        return classElements;
    };

    polyfill.addEventListener = function (node, event, func, useCapture) {
        node = node || document;
        useCapture = useCapture || false;
        if (node.addEventListener) {
            node.addEventListener(event, func, useCapture);
        } else {
            node.attachEvent('on' + event, func);
        }
    };

    polyfill.removeEventListener = function (node, event, func, useCapture) {
        node = node || document;
        useCapture = useCapture || false;
        if (node.removeEventListener) {
            node.removeEventListener(event, func, useCapture);
        } else {
            node.detachEvent('on' + event, func);
        }
    };

    polyfill.arrayFilter = function () {
        if (!Array.prototype.filter) {
            Array.prototype.filter = function (fun /*, thisp */) {
                if (this === void 0 || this === null) {
                    throw TypeError();
                }
                var t = Object(this);
                var len = t.length >>> 0;
                if (typeof fun !== 'function') {
                    throw TypeError();
                }
                var res = [];
                var thisp = arguments[1],
                    i;
                for (i = 0; i < len; i++) {
                    if (i in t) {
                        var val = t[i]; // in case fun mutates this
                        if (fun.call(thisp, val, i, t)) {
                            res.push(val);
                        }
                    }
                }
                return res;
            };
        }
    };

    polyfill.funcBind = function () {
        if (!Function.prototype.bind) {
            Function.prototype.bind = function (oThis) {
                if (typeof this !== 'function') {
                    // closest thing possible to the ECMAScript 5 internal IsCallable function
                    throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
                }
                var aArgs = Array.prototype.slice.call(arguments, 1),
                    fToBind = this,
                    fNOP = function fNOP() {},
                    fBound = function fBound() {
                    return fToBind.apply(this instanceof fNOP && oThis ? this : oThis || window, aArgs.concat(Array.prototype.slice.call(arguments)));
                };
                fNOP.prototype = this.prototype;
                fBound.prototype = new fNOP();
                return fBound;
            };
        }
    };

    polyfill.arrayFilter();
    polyfill.funcBind();

    return polyfill;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/utils/polyfill.js
 ** module id = 66
 ** module chunks = 0
 **/